import { LANGUAGE } from '@/env';
import { getCurrencyCode } from '@/utilities/language';
import { CurrencyCode } from '@/utilities/price';

export const CURRENT_CURRENCY: CurrencyCode = getCurrencyCode(LANGUAGE);

export function getCurrencyCodeText(code: CurrencyCode): string {
  switch (code) {
    case CurrencyCode.CZK:
      return 'Kč';
    case CurrencyCode.EUR:
      return '€';
    default: {
      const _exhaustiveCheck: never = code;
      throw new Error(`Unsupported currency code: ${code}`);
    }
  }
}
